import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "./pages/Landing";
import { Header } from "./components/Header";
import { Toaster } from "sonner";
import { legalPlaceholders } from "./mock";
import { Footer } from "./components/Footer";

function LegalPage({ title, content }) {
  React.useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div style={{ background: "var(--bg-primary)", minHeight: "100vh" }}>
      <Header />
      <main className="dark-content-container" style={{ paddingTop: 120, paddingBottom: 80 }}>
        <h1 className="display-large mb-6">{title}</h1>
        <pre className="body-small" style={{ whiteSpace: "pre-wrap", border: "1px solid var(--border-subtle)", padding: 24, background: "var(--bg-secondary)" }}>{content}</pre>
      </main>
      <Footer />
    </div>
  );
}

function AppShell() {
  const location = useLocation();
  return (
    <div>
      {location.pathname === "/" ? <Header /> : null}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/mentions-legales" element={<LegalPage title="Mentions légales" content={legalPlaceholders.mentions} />} />
        <Route path="/cgu" element={<LegalPage title="Conditions Générales d’Utilisation" content={legalPlaceholders.cgu} />} />
      </Routes>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}
